import type { UserRole } from "../types/user";

export type Permission =
  | "projects.view"
  | "projects.create"
  | "projects.edit"
  | "projects.archive"
  | "projects.delete"
  | "pipeline.run"
  | "pipeline.approve"
  | "viewer.open"
  | "settings.view"
  | "settings.edit_own_profile"
  | "settings.company"
  | "settings.team"
  | "settings.roles"
  | "settings.custom_fields";

const ROLE_PERMISSIONS: Record<UserRole, Set<Permission>> = {
  admin: new Set([
    "projects.view", "projects.create", "projects.edit", "projects.archive", "projects.delete",
    "pipeline.run", "pipeline.approve", "viewer.open",
    "settings.view", "settings.edit_own_profile", "settings.company", "settings.team", "settings.roles", "settings.custom_fields",
  ]),
  engineer: new Set([
    "projects.view", "projects.create", "projects.edit",
    "pipeline.run", "pipeline.approve", "viewer.open",
    "settings.view", "settings.edit_own_profile",
  ]),
  reviewer: new Set([
    "projects.view",
    "pipeline.approve", "viewer.open",
    "settings.view", "settings.edit_own_profile",
  ]),
  viewer: new Set([
    "projects.view", "viewer.open",
    "settings.view", "settings.edit_own_profile",
  ]),
};

export function can(role: UserRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role]?.has(permission) ?? false;
}
